/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@madeeasy/universal-login';
import { initVideoWatchTrackerIntegration, resetVideoWatchTracker, resumeVideoAfterDismiss } from '../../utils/video-watch-tracker-integration';
import { useUser } from '../../contexts/ssr-user-context';

function VideoPopup({
  videoUrl, onClose, pageType, messageData, PopuptypeValue, selectedCourseName, selectHandle, courseClassUl,
}) {
  const [showLogin, setShowLogin] = useState(false);
  const popupRef = useRef();
  const { user } = useUser();

  useEffect(() => {
    const cleanup = initVideoWatchTrackerIntegration(setShowLogin);
    return cleanup;
  }, []);

  useEffect(() => {
    if (user?.id) {
      resetVideoWatchTracker();
    }
  }, [user?.id]);

  const handleDismiss = () => {
    resumeVideoAfterDismiss(); // ← Resume video
    setShowLogin(false);
  };

  // Function to enable fullscreen
  const openFullscreen = () => {
    if (popupRef.current) {
      if (popupRef.current.requestFullscreen) {
        popupRef.current.requestFullscreen();
      } else if (popupRef.current.webkitRequestFullscreen) { // For Safari
        popupRef.current.webkitRequestFullscreen();
      } else if (popupRef.current.msRequestFullscreen) { // For IE/Edge
        popupRef.current.msRequestFullscreen();
      }
    }
  };

  // Trigger fullscreen when the popup opens
  useEffect(() => {
    if (videoUrl) {
      openFullscreen();
    }
  }, [videoUrl]);

  // video embeded url
  function getYouTubeVideoID(url) {
    // eslint-disable-next-line no-useless-escape
    // const regex = /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const regex = /(?:youtube\.com\/(?:.*v=|(?:live|embed)\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }
  // END
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1000] px-4" onClick={onClose}>

      {videoUrl && pageType !== 'Attendance' && (
        <div
          ref={popupRef}
          className="bg-white rounded-lg shadow-lg relative w-full h-full"
          onClick={(e) => e.stopPropagation()} // Prevent closing the popup when clicking inside
        >
          {/* Close Button */}
          <button
            type="button"
            onClick={onClose}
            className="absolute top-4 right-4 text-2xl text-gray-600 bg-gray-200 rounded-full w-10 h-10 flex items-center justify-center"
          >
            &times;
          </button>
          {showLogin ? (
            <div className="fixed inset-0 z-[1100] bg-black bg-opacity-75 flex items-center justify-center">
              {/* eslint-disable-next-line react/jsx-no-bind */}
              <Modal toggleModal={handleDismiss} text="Login" />
            </div>
          ) : null}
          {/* Video Content */}
          <div className="w-full h-full flex items-center justify-center bg-black">
            <iframe
              src={`https://www.youtube.com/embed/${getYouTubeVideoID(videoUrl)}`}
              title="Video Player"
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      )}
      { pageType === 'Attendance' && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1000] px-8" onClick={onClose}>
          <div className="bg-white rounded-md shadow-lg p-5 lg:max-w-[500px] w-full relative" onClick={(e) => e.stopPropagation()}>
            <header className="flex justify-between border-b border-[#D4EEFD] pb-4">
              <h5 className="lg:text-[22px] text-lg font-semibold">{PopuptypeValue === 'change' ? 'Select the Course' : 'Attendance Logic' }</h5>
              <button type="button" onClick={onClose} className="absolute top-3 right-3 text-xl text-gray-600">
                <svg width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.47635 7.24449L13.8632 1.85769C14.1756 1.54529 14.1756 1.03889 13.8632 0.726488C13.5512 0.414087 13.044 0.414087 12.732 0.726488L7.34515 6.11329L1.95915 0.726488C1.64715 0.414087 1.14035 0.414087 0.827951 0.726488C0.515551 1.03889 0.515551 1.54529 0.827951 1.85769L6.21395 7.24449L0.496751 12.9617C0.184351 13.2741 0.184351 13.7805 0.496751 14.0929C0.652751 14.2493 0.85755 14.3273 1.06235 14.3273C1.26715 14.3273 1.47195 14.2493 1.62795 14.0929L7.34515 8.37569L13.0624 14.0929C13.2188 14.2493 13.4232 14.3273 13.628 14.3273C13.8328 14.3273 14.0372 14.2493 14.1936 14.0929C14.506 13.7805 14.506 13.2741 14.1936 12.9617L8.47635 7.24449Z" fill="#0F172A" />
                </svg>
              </button>
            </header>
            <div className="pt-[22px]">
              <ul className={`${courseClassUl}`}>
                {
                  messageData && messageData.map((res) => (
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <li className={`${PopuptypeValue === 'change' ? 'cursor-pointer border border-[#B8E5FF] rounded-lg mb-5 py-4 lg:px-5 px-[14px]' : 'pb-[14px]'} ${selectedCourseName === res?.name ? 'border-b-4 border-b-darkBlue' : ''} `} key={res?.id} onClick={() => selectHandle(res?.name, res?.id, res?.course?.type)}>
                      <strong className={`lg:text-lg text-sm font-semibold block  ${PopuptypeValue === 'change' ? '' : 'lg:pb-2 pb-[6px]'}`}>{res?.name}</strong>
                      <p className="lg:text-sm text-xs font-normal lg:leading-6 leading-[22px]">{res?.des}</p>
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

VideoPopup.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  messageData: PropTypes.array,
  PopuptypeValue: PropTypes.any,
  pageType: PropTypes.any,
  selectedCourseName: PropTypes.any,
  selectHandle: PropTypes.any,
  courseClassUl: PropTypes.any,
};

export default VideoPopup;
